import $ from 'jquery';

$('.numbered-slider__items').slick({
    autoplay: false,
    autoplaySpeed: 7000,
    fade: false,
    infinite: false,
    arrows: true,
    dots: true,
    draggable: true,
    mobileFirst: true,
    prevArrow: '<svg class="slick-prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><defs><style>.cls-1{fill:#7f7f7f;}</style></defs><path class="cls-1" d="M16.93942,22.35348,11.293,16.70711a1,1,0,0,1,0-1.41422l5.64638-5.64637a.5.5,0,0,1,.7071,0l.707.707a.5.5,0,0,1,0,.7071L13.41406,16l4.93942,4.93942a.5.5,0,0,1,0,.7071l-.707.707A.5.5,0,0,1,16.93942,22.35348Z"/></svg>',
    nextArrow: '<svg class="slick-next" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><defs><style>.cls-1{fill:#7f7f7f;}</style></defs><path class="cls-1" d="M14.35348,22.35348l-.707-.707a.5.5,0,0,1,0-.7071L18.58594,16l-4.93942-4.93942a.5.5,0,0,1,0-.7071l.707-.707a.5.5,0,0,1,.7071,0L20.707,15.29289a1,1,0,0,1,0,1.41422l-5.64638,5.64637A.5.5,0,0,1,14.35348,22.35348Z"/></svg>',
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            },
        },
        {
            breakpoint: 1023,
            settings: {
                draggable: false,
                slidesToShow: 2,
                slidesToScroll: 2,
            },
        },
        {
            breakpoint: 1279,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            },
        }
    ]
});
